import { MQ_LARGE, MQ_MEDIUM } from 'common/constants/MediaQueries';
import eventEmitter, { EventsTypes } from 'common/services/events/eventEmitter';
import {
  hasClass,
  addClass,
  removeClass,
  toggleClass
} from 'common/tools/dom/classes';
import * as events from 'common/tools/dom/events';
import isVisible from 'common/tools/dom/is-visible';
import { getStateIndex } from 'common/tools/dom/mq-state';
import { runAfterDesobfuscation } from 'common/tools/seo/desobfuscation';

let currentSubNav: Element;
let mdItemCopied = false;
let smItemCopied = false;

function initThirdNavTrigger(navItem: Element) {
  const btnTriggerSubNav = navItem.getElementsByClassName(
    'js-trigger-third-nav-sub'
  )[0];

  function showSubNav() {
    if (currentSubNav && currentSubNav !== navItem) {
      removeClass(currentSubNav, 'show-sub');
    }

    toggleClass(navItem, 'show-sub');
    currentSubNav = navItem;
    events.on(document.body, 'click', hideSubNav);
  }

  function hideSubNav() {
    if (hasClass(navItem, 'show-sub') && btnTriggerSubNav) {
      toggleClass(navItem, 'show-sub');
      events.off(document.body, 'click', hideSubNav);
    }
  }

  function triggerSubNav(ev: Event) {
    ev.preventDefault();
    ev.stopPropagation();
    showSubNav();
  }

  if (btnTriggerSubNav) {
    events.on(btnTriggerSubNav, 'click', triggerSubNav);
  }
}

function subNavCurrent(thirdNav: HTMLCollectionOf<Element>) {
  if (!thirdNav.length) {
    return;
  }

  for (const nav of thirdNav) {
    const thirdNavSubHolder = nav.getElementsByClassName(
      'js-third-sub-nav-holder'
    )[0];

    if (thirdNavSubHolder) {
      const items = thirdNavSubHolder.getElementsByClassName('item');
      const itemsJs =
        thirdNavSubHolder.getElementsByClassName('js-item-mq-medium');

      if (
        items.length !== itemsJs.length ||
        (itemsJs.length && isVisible(itemsJs[0]))
      ) {
        removeClass(thirdNavSubHolder, 'item-more-hidden');
      } else {
        addClass(thirdNavSubHolder, 'item-more-hidden');
      }

      const current = thirdNavSubHolder.getElementsByClassName('current');

      if (current.length && isVisible(current[0])) {
        addClass(thirdNavSubHolder, 'current');
      } else {
        removeClass(thirdNavSubHolder, 'current');
      }
    }
  }
}

function copieMqMediumItem(thirdNav: HTMLCollectionOf<Element>) {
  if (mdItemCopied || !thirdNav.length) {
    return false;
  }

  for (const nav of thirdNav) {
    const thirdNavSub = nav.getElementsByClassName('js-third-nav-sub')[0];
    const itemsToCopy = nav.getElementsByClassName('js-item-mq-medium');

    if (itemsToCopy.length && thirdNavSub) {
      const domToHold = document.createDocumentFragment();

      for (const itemToClone of itemsToCopy) {
        const tmp = itemToClone.cloneNode(true);
        domToHold.appendChild(tmp);
      }

      thirdNavSub.insertBefore(
        domToHold,
        thirdNavSub.getElementsByClassName('item')[0]
      );

      mdItemCopied = true;
    }
  }
}

function copieMqSmallItem(thirdNav: HTMLCollectionOf<Element>) {
  if (smItemCopied || !thirdNav.length) {
    return false;
  }

  for (const nav of thirdNav) {
    const thirdNavSub = nav.getElementsByClassName('js-third-nav-sub')[0];

    if (!thirdNavSub) {
      return false;
    }

    const itemsToCopy = nav.getElementsByClassName('js-item-mq-small');

    if (itemsToCopy.length) {
      const domToHold = document.createDocumentFragment();

      for (const itemToClone of itemsToCopy) {
        domToHold.appendChild(itemToClone.cloneNode(true));
      }

      thirdNavSub.insertBefore(
        domToHold,
        thirdNavSub.getElementsByClassName('item')[0]
      );

      smItemCopied = true;
    }
  }
}

const stateChanged = (state: number, thirdNav: HTMLCollectionOf<Element>) => {
  if (state < MQ_LARGE) {
    copieMqMediumItem(thirdNav);
  }
  if (state < MQ_MEDIUM) {
    copieMqSmallItem(thirdNav);
  }

  subNavCurrent(thirdNav);
};

export function createThirdNav(
  thirdNav: HTMLCollectionOf<Element>,
  forcedItem: Element | null
) {
  if (!thirdNav.length) {
    return;
  }

  const currentMqState = getStateIndex();

  for (const nav of thirdNav) {
    initThirdNavTrigger(nav);
  }

  runAfterDesobfuscation(stateChanged.bind(null, currentMqState, thirdNav));

  eventEmitter.on(EventsTypes.MQ_STATE, state => {
    stateChanged(state, thirdNav);
  });

  if (forcedItem) {
    toggleClass(forcedItem, 'show-sub');
    currentSubNav = forcedItem;
  }
}
